import React, { useState } from 'react';
import api from '../services/api';

export default function Frota({ frotaList = [], setFrotaList, motoristasList = [] }) {
  const [placa, setPlaca] = useState('');
  const [modelo, setModelo] = useState('');
  const [motorista, setMotorista] = useState('');
  const [consumo, setConsumo] = useState('');
  const [status, setStatus] = useState('Disponível');
  const [editandoId, setEditandoId] = useState(null);

  const frota = Array.isArray(frotaList) ? frotaList : [];

  const handleSalvar = async (e) => {
    e.preventDefault();
    if (!placa || !modelo) return alert('Preencha a placa e o modelo.');

    try {
      if (editandoId) {
        await api.put(`/frota/${editandoId}`, { placa, modelo, motorista, consumo, status });
        setFrotaList(frota.map(f => f.id === editandoId ? { ...f, placa, modelo, motorista, consumo, status } : f));
        setEditandoId(null);
        alert('Veículo atualizado com sucesso!');
      } else {
        const novoVeiculo = { id: Date.now().toString(), placa, modelo, motorista, consumo, status };
        await api.post('/frota', novoVeiculo);
        setFrotaList([...frota, novoVeiculo]);
        alert('Veículo cadastrado com sucesso!');
      }
      setPlaca(''); setModelo(''); setMotorista(''); setConsumo(''); setStatus('Disponível');
    } catch (err) {
      console.error("Erro detalhado:", err.response || err);
      alert('Erro ao salvar veículo no servidor.');
    }
  };

  const handleEditar = (f) => {
    setEditandoId(f.id);
    setPlaca(f.placa || '');
    setModelo(f.modelo || '');
    setMotorista(f.motorista || '');
    setConsumo(f.consumo || '');
    setStatus(f.status || 'Disponível');
  };

  const handleDeletar = async (id) => {
    if (!window.confirm("Deseja excluir este veículo?")) return;
    try {
      await api.delete(`/frota/${id}`);
      setFrotaList(frota.filter(f => f.id !== id));
    } catch (err) {
      console.error(err);
      alert('Erro ao excluir do servidor.');
    }
  };

  return (
    <div style={{ width: '100%', boxSizing: 'border-box' }}>
      <div style={{ marginBottom: '24px' }}>
        <span style={{ fontSize: '11px', textTransform: 'uppercase', color: '#777', letterSpacing: '1.5px', fontWeight: 'bold' }}>Frota & Monitoria</span>
        <h2 style={{ fontSize: '24px', fontWeight: '800', margin: '4px 0 0 0' }}>Gestão de Veículos</h2>
      </div>

      <div style={{ backgroundColor: '#141414', border: '1px solid #222', padding: '24px', borderRadius: '8px', marginBottom: '24px' }}>
        <h3 style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '16px', color: '#007AFF' }}>
          {editandoId ? '✏️ Editar Veículo' : '+ Cadastrar Novo Veículo'}
        </h3>
        <form onSubmit={handleSalvar} style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '14px', alignItems: 'end' }}>
          <div>
            <label style={{ display: 'block', fontSize: '11px', textTransform: 'uppercase', color: '#888', fontWeight: 'bold', marginBottom: '6px' }}>Placa</label>
            <input type="text" placeholder="ABC1D23" value={placa} onChange={e => setPlaca(e.target.value)} style={{ width: '100%', padding: '12px', backgroundColor: '#1a1a1a', border: '1px solid #333', borderRadius: '6px', color: '#fff', boxSizing: 'border-box' }} required />
          </div>
          <div>
            <label style={{ display: 'block', fontSize: '11px', textTransform: 'uppercase', color: '#888', fontWeight: 'bold', marginBottom: '6px' }}>Modelo</label>
            <input type="text" placeholder="Volvo FH 540" value={modelo} onChange={e => setModelo(e.target.value)} style={{ width: '100%', padding: '12px', backgroundColor: '#1a1a1a', border: '1px solid #333', borderRadius: '6px', color: '#fff', boxSizing: 'border-box' }} required />
          </div>
          <div>
            <label style={{ display: 'block', fontSize: '11px', textTransform: 'uppercase', color: '#888', fontWeight: 'bold', marginBottom: '6px' }}>Motorista</label>
            <select value={motorista} onChange={e => setMotorista(e.target.value)} style={{ width: '100%', padding: '12px', backgroundColor: '#1a1a1a', border: '1px solid #333', borderRadius: '6px', color: '#fff', boxSizing: 'border-box' }}>
              <option value="">Selecione (opcional)</option>
              {motoristasList.map(m => <option key={m.id} value={m.nome}>{m.nome}</option>)}
            </select>
          </div>
          <div>
            <label style={{ display: 'block', fontSize: '11px', textTransform: 'uppercase', color: '#888', fontWeight: 'bold', marginBottom: '6px' }}>Status</label>
            <select value={status} onChange={e => setStatus(e.target.value)} style={{ width: '100%', padding: '12px', backgroundColor: '#1a1a1a', border: '1px solid #333', borderRadius: '6px', color: '#fff', boxSizing: 'border-box' }}>
              <option value="Disponível">Disponível</option>
              <option value="Em Viagem">Em Viagem</option>
              <option value="Manutenção">Manutenção</option>
            </select>
          </div>
          <button type="submit" style={{ padding: '12px', backgroundColor: '#007AFF', color: '#fff', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer', height: '43px' }}>
            {editandoId ? 'Salvar Alterações' : 'Adicionar'}
          </button>
        </form>
      </div>

      <div style={{ backgroundColor: '#141414', border: '1px solid #222', padding: '24px', borderRadius: '8px' }}>
        <h3 style={{ fontSize: '12px', textTransform: 'uppercase', letterSpacing: '1px', color: '#888', marginBottom: '16px' }}>Frota Ativa · {frota.length}</h3>
        {frota.length === 0 ? (
          <p style={{ color: '#666', textAlign: 'center', padding: '40px' }}>Nenhum veículo cadastrado ainda.</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {frota.map(f => (
              <div key={f.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px', backgroundColor: '#1a1a1a', borderRadius: '6px', border: '1px solid #333' }}>
                <div>
                  <h4 style={{ margin: 0, fontSize: '15px', fontWeight: 'bold' }}>{f.placa} - {f.modelo}</h4>
                  <p style={{ margin: '4px 0 0 0', fontSize: '12px', color: '#888' }}>Motorista: {f.motorista || 'Não atribuído'} · Status: <span style={{ color: '#32D74B' }}>{f.status}</span></p>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button onClick={() => handleEditar(f)} style={{ padding: '6px 12px', backgroundColor: '#333', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}>Editar</button>
                  <button onClick={() => handleDeletar(f.id)} style={{ padding: '6px 12px', backgroundColor: '#FF3B30', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}>Excluir</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}